<div class="animated fadeIn"><div class="row sfapp-container"><div class="col-md-12"><div class="card">
  <div class="card-header"><span><i class="fa s-icon-list"></i> 一覧 @if (studio && items.length) { <span>(全 {{ filteredItems.length }} 件)</span> }</span></div>
  <div class="card-body">
    @if (error) { <div class="alert alert-danger" role="alert">{{ error }}</div> }
    <div class="row" style="align-items: flex-end;">
      <div class="col-md-3"><div class="form-group">
        <label for="subscriptionStudio" class="col-form-label">店舗選択</label>
        <select id="subscriptionStudio" class="form-control" [(ngModel)]="studio" (ngModelChange)="load()" [disabled]="downloading">
          <option [ngValue]="null">-- 選択してください --</option>
          @for (item of studios; track item.id) { <option [ngValue]="item">{{ item.name }}</option> }
        </select>
      </div></div>
      <div class="col-md-4"><div class="form-group">
        <label for="subscriptionSearch" class="col-form-label">フリーワード検索</label>
        <input id="subscriptionSearch" type="text" class="form-control" [(ngModel)]="query" (ngModelChange)="pageIndex = 0" placeholder="会員ID・会員氏名・商品名" [disabled]="downloading">
      </div></div>
      <div class="col-md-2"><div class="form-group">
        <label for="subscriptionIncludeEnded" class="col-form-label d-block">開始前・終了を含める</label>
        <label class="custom-control custom-checkbox mb-0">
          <input id="subscriptionIncludeEnded" type="checkbox" class="custom-control-input" [(ngModel)]="includeEnded" (ngModelChange)="load()" [disabled]="downloading">
          <span class="custom-control-label"></span>
        </label>
      </div></div>
      <div class="col-md-3 text-right"><div class="form-group">
        <button class="btn btn-success" type="button" (click)="downloadCsv()" [disabled]="searching || downloading || !filteredItems.length">
          <div class="file_format_icon dl"><div><span title="csv"></span><span class="material-icons-outlined">download</span></div></div>
          &nbsp;CSVダウンロード
        </button>
      </div></div>
    </div>
    <hr>
    @if (searching) { <p role="status">検索中…</p> }
    @else if (studio && !items.length) { <span>該当するデータはありません</span> }
    @if (studio && items.length && !searching) {
      <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="pageIndex = $event"></app-pager>
      <table class="table table-bordered table-sm table-hover table-ptb-0">
        @if (filteredItems.length) {
          <thead><tr>
            <th width="8%" class="position-relative"><div class="d-flex align-items-center justify-content-center"><span>状態</span><app-subscription-state-legend /></div></th>
            <th width="12%">会員ID</th><th width="16%">会員氏名</th><th>商品名</th><th width="12%">金額（税込）</th><th width="10%">引渡日</th><th width="12%">開始月</th><th width="12%">終了月</th><th></th>
          </tr></thead>
        }
        <tbody>@for (item of pagedItems; track item.id) {
          <tr>
            <td class="text-center"><span class="material-symbols-outlined" [ngClass]="state(item.status).className" [title]="state(item.status).title" aria-hidden="true" style="font-size: 28px; vertical-align: middle;">{{ state(item.status).icon }}</span><span class="sr-only">{{ state(item.status).title }}</span></td>
            <td>{{ item.member?.memberCode }}</td><td>{{ item.member?.lastName }} {{ item.member?.firstName }}</td>
            <td>{{ item.product?.name }}</td><td class="text-right">¥{{ item.taxIncAmount | number:'1.0-0' }}</td><td class="text-center">{{ deliveryDayLabel(item.deliveryDay) }}</td>
            <td>{{ item.startDate | date:'yyyy年MM月':'+0900' }}</td><td>{{ item.endDate ? (item.endDate | date:'yyyy年MM月':'+0900') : '-' }}</td>
            <td class="text-center">
              <a class="mt-1 mb-1 btn btn-primary btn-sm text-white" [routerLink]="['/subscription', item.member?.id]" title="物販定期便" aria-label="物販定期便"><span class="material-symbols-outlined fa-fw" style="font-size: 14px; vertical-align: middle;">hand_package</span></a>
              <a class="mt-1 mb-1 btn btn-warning btn-sm text-white" [routerLink]="['/transaction', item.member?.id, 'all']" title="売上一覧" aria-label="売上一覧"><i class="fa s-icon-salesList fa-fw"></i></a>
            </td>
          </tr>
        }</tbody>
      </table>
    }
  </div>
</div></div></div></div>
